// src/components/CustomSelect.jsx
import React, { useState, useRef, useEffect } from "react";

export default function CustomSelect({ options, name, defaultValue }) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(defaultValue || options[0].value);
  const ref = useRef();

  const handleSelect = (value) => {
    setSelected(value);
    setOpen(false);
  };

  useEffect(() => {
    const closeOnClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", closeOnClickOutside);
    return () => document.removeEventListener("mousedown", closeOnClickOutside);
  }, []);

  return (
    <div className="relative w-full" ref={ref}>
      <input type="hidden" name={name} value={selected} />
      <button
        type="button"
        className="w-full border border-gray-300 rounded p-2 text-left bg-white"
        onClick={() => setOpen(!open)}
      >
        {options.find((opt) => opt.value === selected)?.label}
      </button>
      {open && (
        <ul className="absolute z-50 w-full bg-white border border-gray-300 rounded mt-1 shadow-md max-h-60 overflow-auto">
          {options.map((opt) => (
            <li
              key={opt.value}
              className={`p-2 cursor-pointer hover:bg-blue-100 ${
                selected === opt.value ? "bg-blue-50" : ""
              }`}
              onClick={() => handleSelect(opt.value)}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
